module.exports = __webpack_public_path__ + "media/src/images/partners/osnabrueck-cddedac3066bf25b198449040ad68d73.jpg";